import S from "./ghl-ui.es1154.js";
import { createTheme as H } from "./ghl-ui.es861.js";
import P from "./ghl-ui.es1145.js";
import u from "./ghl-ui.es894.js";
import M from "./ghl-ui.es933.js";
import T from "./ghl-ui.es1072.js";
import y from "./ghl-ui.es1058.js";
import w from "./ghl-ui.es1151.js";
import z from "./ghl-ui.es1002.js";
import D from "./ghl-ui.es1155.js";
import B from "./ghl-ui.es998.js";
import j from "./ghl-ui.es990.js";
import { composite as o } from "./ghl-ui.es895.js";
const k = (m) => {
  const { cardColor: t, modalColor: e, popoverColor: i, textColor2: C, textColor1: n, tableHeaderColor: l, tableColorHover: r, iconColor: h, primaryColor: d, fontWeightStrong: g, borderRadius: c, lineHeight: b, fontSizeSmall: s, fontSizeMedium: f, fontSizeLarge: v, dividerColor: a, heightSmall: x, opacityDisabled: L, tableColorStriped: p } = m;
  return Object.assign(Object.assign({}, S), {
    actionDividerColor: a,
    lineHeight: b,
    borderRadius: c,
    fontSizeSmall: s,
    fontSizeMedium: f,
    fontSizeLarge: v,
    borderColor: o(t, a),
    tdColorHover: o(t, r),
    tdColorStriped: o(t, p),
    thColor: o(t, l),
    thColorHover: o(o(t, l), r),
    tdColor: t,
    tdTextColor: C,
    thTextColor: n,
    thFontWeight: g,
    thButtonColorHover: r,
    thIconColor: h,
    thIconColorActive: d,
    // modal
    borderColorModal: o(e, a),
    tdColorHoverModal: o(e, r),
    tdColorStripedModal: o(e, p),
    thColorModal: o(e, l),
    thColorHoverModal: o(o(e, l), r),
    tdColorModal: e,
    // popover
    borderColorPopover: o(i, a),
    tdColorHoverPopover: o(i, r),
    tdColorStripedPopover: o(i, p),
    thColorPopover: o(i, l),
    thColorHoverPopover: o(o(i, l), r),
    tdColorPopover: i,
    boxShadowBefore: "inset -12px 0 8px -12px rgba(0, 0, 0, .18)",
    boxShadowAfter: "inset 12px 0 8px -12px rgba(0, 0, 0, .18)",
    // loading
    loadingColor: d,
    loadingSize: x,
    opacityLoading: L
  });
}, A = H({
  name: "DataTable",
  common: P,
  peers: {
    Button: u,
    Checkbox: M,
    Radio: T,
    Pagination: y,
    Scrollbar: w,
    Empty: z,
    Popover: D,
    Ellipsis: B,
    Dropdown: j
  },
  self: k
}), Q = A;
export {
  Q as default,
  k as self
};
